<template>
  <div id="root-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Root',
};
</script>

<style>
</style>